import React from "react";

/**
 * "Airport Pickup Fee" popup content — ported line-for-line from plugin
 * customComponent/airportPickupFeeInfo.jsx. Shared by carSelection,
 * selectedCarDetailsLatest, orderDetails, the airportPickupFeeInfo step and the
 * edit/confirm PageModals/AirportPickupFeeInfo wrapper.
 *
 * The amount is STATIC and Pearson-specific: the copy names the GTAA, and $17.25 is
 * what they charge for pickup access. It is intentionally not read from the pricing
 * breakdown — that row is the amount billed on THIS trip, which is the same figure
 * today but would silently rewrite the GTAA sentence if another airport ever carried
 * a different fee. Change it here (and in the plugin copy) when the GTAA does.
 */
const AIRPORT_FEE_AMOUNT = "$17.25";

const INCLUDED = [
    "Official airport pickup access",
    "Comfortable indoor waiting",
    "No limo lineups",
    "Real-time flight tracking",
    "Immigration, customs & baggage delays covered",
    "Guaranteed pickup",
];

export function AirportPickupFeeInfo() {
    return (
        <div className="hopn-airport-pickup-fee-info">
            <h4 className="hopn-apf-title">Airport Arrival Experience</h4>
            <p className="hopn-apf-lead">
                <strong>{AIRPORT_FEE_AMOUNT}</strong> is paid directly to the Toronto Pearson
                Airport Authority (GTAA) for airport pickup access.
            </p>

            <h5 className="hopn-apf-included">Included:</h5>
            {/* The tick is real markup, not a list marker or a ::before — Tailwind's
                Preflight strips ul markers here, so a CSS-only tick would vanish. */}
            <ul className="hopn-apf-list">
                {INCLUDED.map((line) => (
                    <li key={line}>
                        <span className="hopn-apf-check" aria-hidden="true">✓</span>
                        <span>{line}</span>
                    </li>
                ))}
            </ul>

            <p className="hopn-apf-outro">Land. Collect your bags. hop’n home.</p>
        </div>
    );
}

export default AirportPickupFeeInfo;
